import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/cn-new-year/2026/Index.vue')
const LotteryRewards = () => import('../activity/cn-new-year/2026/LotteryRewards.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/cn-new-year/2026',
  name: 'activity_cn_new_year_2026',
  component: Index,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '新春赛马会 丝路任我行',
  },
}

export const lotteryRewardsRoute: RouteConfig = {
  path: '/activity/cn-new-year/2026/lottery-rewards',
  name: 'activity_cn_new_year_2026_lottery_rewards',
  component: LotteryRewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export default [indexRoute, lotteryRewardsRoute]
